import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useGetIntegrationPartnersQuery } from '@app/services/integration-config';
import type {
  IntegrationPartner,
  CarrierConfigurationStep,
  CarrierEnablementStep,
} from '@app/types/api/organization';

import { formatPartnerDisplayName } from '../partials/partner-info';

export interface PartnerContext {
  partnerName: string;
  displayName: string;
  partnerConfig: IntegrationPartner | undefined;
  carrierConfiguration: CarrierConfigurationStep[];
  carrierEnablement: CarrierEnablementStep[];
  enabled: boolean;
  isLoading: boolean;
}

export const usePartnerContext = (): PartnerContext => {
  const { partnerName: rawPartnerName } = useParams<{
    partnerName: string;
  }>();
  const partnerName = (rawPartnerName ?? '').toLowerCase();
  const { partners, isLoading } = useGetIntegrationPartnersQuery();

  const partnerConfig = useMemo(
    () =>
      (partners as IntegrationPartner[] | undefined)?.find(
        (p) => p.partnerName.toLowerCase() === partnerName,
      ),
    [partners, partnerName],
  );

  const displayName = formatPartnerDisplayName(rawPartnerName ?? '');

  return {
    partnerName,
    displayName,
    partnerConfig,
    carrierConfiguration: partnerConfig?.carrierConfiguration ?? [],
    carrierEnablement: partnerConfig?.carrierEnablement ?? [],
    enabled: partnerConfig?.enabled ?? false,
    isLoading,
  };
};
